interface Product {
  grouping: boolean;
  groupingAttributes: { groupMembers: { itemNumber: string }[] };
  itemNumber: string;
}

export default ({
  grouping,
  groupingAttributes,
  itemNumber,
}: Product): boolean => {
  return (
    !grouping ||
    !!groupingAttributes?.groupMembers?.some(
      (x) => x.itemNumber.toLowerCase() === itemNumber?.toLowerCase()
    )
  );
};
